import Typography from "@mui/joy/Typography";
import SimpleFormAnswerTable from "./SimpleFormAnswerTable";
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Link from "@mui/joy/Link";
import {Link as RouterLink} from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

export default function SimpleFormAnswerPage() {
  return (
    <>
      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <Breadcrumbs
          size="sm"
          aria-label="breadcrumbs"
          separator={<ChevronRightRoundedIcon fontSize="small"/>}
          sx={{pl: 0}}
        >
          <Link
            underline="none"
            color="neutral"
            component={RouterLink}
            to="/console"
            aria-label="Home"
          >
            <HomeRoundedIcon/>
          </Link>
          <Typography fontWeight={500} fontSize={12}>
            간편문진
          </Typography>
          <Typography color="primary" fontWeight={500} fontSize={12}>
            응답지 조회
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: {xs: 'column', sm: 'row'},
          alignItems: {xs: 'start', sm: 'center'},
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >

        <Typography level="h2" component="h1">
          응답지 조회
        </Typography>


        {/* <Link
          underline="none"
          color="neutral"
          component={RouterLink}
          to="/console/partner/create"
        >
          <Button
            color="primary"
            startDecorator={<AddRoundedIcon/>}
            size="sm"
          >
            파트너 생성
          </Button>
        </Link> */}
      </Box>
      <SimpleFormAnswerTable/>
    </>
  );
}